import { Html, Link, Row } from '@react-email/components'
import * as React from 'react'

export interface RemovedFromJobEmailProps {
  currentUser: string
  siteName: string
  url: string
}

export const RemovedFromJobEmail = (props: RemovedFromJobEmailProps) => {
  const { siteName, currentUser, url } = props

  return (
    <Html lang='en'>
      <Row>
        {currentUser} has removed you from a job at {siteName}.
      </Row>
      <Row>
        <Link href={url}>Handoff Page</Link>
      </Row>
      <Row>If needed, reach out to {currentUser} for additional info. </Row>
    </Html>
  )
}
